import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeft,
  faBars,
  faXmark,
} from '@fortawesome/pro-regular-svg-icons';
import { useBreakpoints } from '@design-system/breakpointsStore';
import { PlaybookLogo } from '@design-system/components/logo/PlaybookLogo';
import {
  navMenuHeader,
  hamburgerIcon,
  headerDisplayName,
  backButtonLabel,
  avatar,
} from './navMenu.css';
import { Link } from 'react-router';
import { PATHS } from '@client/routes';
import { Typography } from '../typography/typography';

type NavMenuHeaderProps = {
  isMenuOpen?: boolean;
  onMenuToggle?: () => void;
  isAdmin?: boolean;
  displayName?: string;
  avatar?: string;
};

export const NavMenuHeader = (p: NavMenuHeaderProps) => {
  const breakpoint = useBreakpoints();
  // todo fix tablet and mobile view for admin
  return (
    <header className={navMenuHeader}>
      {p.isAdmin ? null : (
        <PlaybookLogo height={18} showGlyph showName={!breakpoint.tablet} />
      )}
      {!p.isAdmin ? null : (
        <div className="flex flex-col gap-2 justify-end h-full">
          <Link to={PATHS.HOME} className="text-white text-base">
            <div className="flex items-center gap-4">
              <FontAwesomeIcon icon={faArrowLeft} />
              <Typography className={backButtonLabel}>All creators</Typography>
            </div>
          </Link>
          <div className="flex items-center justify-between py-2 lg:py-t-10">
            <div className="flex items-center gap-3">
              {!p.avatar ? null : (
                <div>
                  <img className={avatar} src={p.avatar} />
                </div>
              )}
              {!p.displayName ? null : (
                <span className={headerDisplayName}>{p.displayName}</span>
              )}
            </div>
          </div>
        </div>
      )}
      <div className={hamburgerIcon} onClick={p.onMenuToggle}>
        <FontAwesomeIcon
          width={18}
          height={20}
          icon={p.isMenuOpen ? faXmark : faBars}
        />
      </div>
    </header>
  );
};
